import { IconWarningSign16 } from '@cian/ui-kit';

import { type FC, type SyntheticEvent, useCallback } from 'react';

import { NarrowCardMoreControlsItem } from '../../../../../components/desktop/NarrowCardMoreControlsItem';
import { useComplaintToOfferAction } from '../../../../../hooks/useComplaintToOfferAction';

export const MoreItemComplaintContainer: FC = () => {
  const complaintToOffer = useComplaintToOfferAction();

  const handleClick = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
      complaintToOffer();
    },
    [complaintToOffer],
  );

  return <NarrowCardMoreControlsItem icon={<IconWarningSign16 />} title="Пожаловаться" onClick={handleClick} />;
};
